import axios from 'axios';
import {
  RUNNING_TYPE,
  RUNNING_TYPE_MASTER,
  RUNNING_TYPE_DEVELOP,
  RUNNING_TYPE_LOCAL,
  API_URL,
  API_DEV_URL,
  API_LOCAL_URL,
  FILE_UPLOAD_API,
  API_KEY,
  API_KEY_RC_TEST,
} from '../util/Const';

// ファイルアップロードAPI
export const PostFileUpload = async (formData: FormData) => {
  let url: string;
  let apiKey: string;
  switch (RUNNING_TYPE) {
    case RUNNING_TYPE_MASTER:
      url = API_URL + FILE_UPLOAD_API;
      apiKey = API_KEY;
      break;
    case RUNNING_TYPE_DEVELOP:
      url = API_DEV_URL + FILE_UPLOAD_API;
      apiKey = API_KEY_RC_TEST;
      break;
    case RUNNING_TYPE_LOCAL + FILE_UPLOAD_API:
      url = API_LOCAL_URL;
      apiKey = API_KEY_RC_TEST;
      break;
    default:
      url = '';
      apiKey = '';
      break;
  }

  if (
    RUNNING_TYPE === RUNNING_TYPE_MASTER ||
    RUNNING_TYPE === RUNNING_TYPE_DEVELOP ||
    RUNNING_TYPE === RUNNING_TYPE_LOCAL
  ) {
    const res = await axios
      .post(url, formData, {
        headers: {
          'x-api-key': apiKey,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw error;
      });
    return res;
  }
  const res = await axios
    .get(url)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error;
    });
  return res;
};

export default PostFileUpload;
